import { FC, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, useMediaQuery } from '@mui/material';
import { useQuery } from 'react-query';
import { Table, MobileTable, Page, PageTitleWithBack } from '../../../components';
import { getCompactionTestNeighborhoods } from '../../../fetch/compaction-tests';
import { ICompactionTestNeighborhood } from '../../../models/compaction-tests';

interface ICompactionTests {}

export const CompactionTests: FC<ICompactionTests> = () => {
  const history = useHistory();
  const isMobile = useMediaQuery('(max-width: 960px)');
  const { isLoading, data: neighborhoods = [] } = useQuery<ICompactionTestNeighborhood[], Error>(
    ['getCompactionTestNeighborhoods'],
    () => getCompactionTestNeighborhoods()
  );

  const handleSelectNeighborhood = (neighborhood: ICompactionTestNeighborhood) => {
    history.push(`/vendors/compaction-tests/${neighborhood.neighborhoodId}`, {
      neighborhoodName: neighborhood.neighborhoodName
    });
  };

  const neighborhoodsColumns = useMemo(() => {
    return [
      {
        Header: 'Territory',
        accessor: 'territoryName',
        sort: false
      },
      {
        Header: 'Neighborhood',
        accessor: 'neighborhoodName',
        sort: false
      },
      {
        id: 'actions',
        Header: '',
        accessor: '',
        sort: false,
        Cell: ({
          cell: {
            row: { original }
          }
        }: {
          cell: { row: { original: ICompactionTestNeighborhood } };
        }) => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleSelectNeighborhood(original)}
            >
              Select
            </Button>
          );
        }
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Compaction Tests">
      <PageTitleWithBack title="Compaction Tests" backText="Back to Vendors" backUrl={'/vendors'} />
      <Table
        columns={neighborhoodsColumns}
        data={neighborhoods}
        isLoading={isLoading}
        hidePagination
        mobileProps={{
          fields: neighborhoodsColumns
            .filter(c => c.Header)
            .map(c => ({
              name: c.Header as string,
              accessor: c.accessor as string,
              Cell: c?.Cell
            })),
          mobileDefaultAccessor: 'neighborhoodName',
          handleView: (neighborhood: ICompactionTestNeighborhood) => {
            handleSelectNeighborhood(neighborhood);
          }
        }}
        ResponsiveComponent={isMobile ? MobileTable : undefined}
      />
    </Page>
  );
};
